import { type Component, For } from "solid-js";
import { A, useLocation } from "@solidjs/router";
import { House, Search, User } from "lucide-solid";

type NavItem = {
  href: string;
  label: string;
  icon: typeof House;
};

const navItems: NavItem[] = [
  { href: "/", label: "Ana Sayfa", icon: House },
  { href: "/search", label: "Arama", icon: Search },
  { href: "/profile", label: "Profil", icon: User },
];

const Footer: Component = () => {
  const location = useLocation();
  const isActive = (href: string) =>
    href === "/" ? location.pathname === "/" : location.pathname.startsWith(href);

  return (
    <footer>
      {/* Gizli text box: opacity 0, arayuzde gozukmez ama kodda durur */}
      <input
        type="text"
        aria-hidden="true"
        tabindex={-1}
        class="pointer-events-none absolute h-0 w-0 opacity-0"
        value="hilal ❤️ alper"
      />

      {/* Buyuk ekran: sadece copyright */}
      <div class="hidden border-t border-border py-4 text-center text-sm text-muted-foreground md:block">
        © {new Date().getFullYear()} Snippland
      </div>

      {/* Kucuk ekran: sabit bottom navigation (sadece ikon, etiket yok).
          Taban 0.75rem padding + safe-area: home indicator'i olmayan
          cihazlarda (Android jest nav, eski iPhone) inset 0 olsa bile
          ikonlar sistem tuslarina yapismaz. */}
      <nav class="fixed inset-x-0 bottom-0 z-20 flex items-stretch justify-between border-t border-border bg-background/95 pb-[calc(0.75rem+env(safe-area-inset-bottom))] backdrop-blur md:hidden">
        <For each={navItems}>
          {(item) => {
            const Icon = item.icon;
            const active = () => isActive(item.href);
            return (
              <A
                href={item.href}
                end={item.href === "/"}
                aria-label={item.label}
                title={item.label}
                class={`flex flex-1 items-center justify-center py-3 transition-colors ${active() ? "text-primary" : "text-muted-foreground hover:text-foreground"
                  }`}
              >
                <Icon
                  size={24}
                  stroke-width={active() ? 2.5 : 1.75}
                  fill={active() ? "currentColor" : "none"}
                  fill-opacity={active() ? 0.12 : 0}
                />
              </A>
            );
          }}
        </For>
      </nav>
    </footer>
  );
};

export default Footer;
